import React, { useContext, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import useDocumentTitle from "../../components/helpers/useDocumentTitle";
import PageHeader from "../../components/shared/PageHeader";
import PageMain from "../../containers/shared/PageMain";
import apiClient from "../../components/utils/apiClient";
import MainContent from "../../containers/shared/MainContent";
import NormalFormContainer from "../../containers/shared/NormalFormContainer";
import InputField from "../../components/shared/InputField";
import SelectField from "../../components/shared/SelectField";
import NormalButton from "../../components/shared/NormalButton";
import useUser from "../../components/helpers/useUser";
import Loading from "../../components/shared/Loading";
import { UserContext } from "../../App";
import { FIELDS, firebaseConfig } from "../../components/utils/constants";
import Toast from "../../components/shared/Toast";
import MultiSelect from "../../components/shared/MultiSelect";
import FilterSelectedValues from "../../components/helpers/filterSelectedValues";
import SingleImageCompress from "../../components/helpers/SingleImageCompress";
import {initializeApp, getApp, getApps} from "firebase/app";
import { getStorage, getDownloadURL, uploadBytesResumable, ref } from "firebase/storage";
import moment from "moment";

const UsersAddPage = () => {
    const {t,i18n} = useTranslation();
    useDocumentTitle(t('workers.addWorkerTitle'));
    const navigate = useNavigate();
    const pageTitle = {title: t('workers.addWorkerTitle')};
    const [addUserForm,setAddUserForm] = useState({name: '', mobile: '', email:'', role: '', propertyIds:[], companyName: 'defult', unitIds:[], field:[] });
    const [errors, setErrors] = useState(null);
    const [isAddUserFormDisabled, setIsAddUserFormDisabled] = useState(true);
    const [isActionLoading, setIsActionLoading] = useState(false);
    const [user,setUser] = useUser();
    const [vendor, setVendor] = useState(null);
    const {confguration, fields} = useContext(UserContext);
    const [citiesOptions, setCitiesOptions] = useState(null);
    const [districtsOptions, setDistrictsOptions] = useState(null);
    const [fieldsOptions, setFieldsOptions] = useState(null);
    const [subFieldsOptions, setSubFieldsOptions] = useState(null);
    const [toast, setToast] = useState({show: false,type: null, message:'' });
    const [uploadedFile, setUploadedFile] = useState(null);
    const [compressedImage, setCompressedImage] = useState(null);
    const [selectedGoldiePlan, setSelectedGoldiePlan] = useState(null);
    const [uploadedFileUrl, setUploadedFileUrl] = useState(null);

    const convertArabicNumbersToEnglish = string =>
  // eslint-disable-next-line no-bitwise
  string?.replace(/[\u0660-\u0669\u06f0-\u06f9]/g, c => c.charCodeAt(0) & 0xf);

    useEffect(()=>{
        if(fields && vendor) {
            setFieldsOptions(fields?.filter(f=>vendor?.fields?.includes(f?.field?.code))?.map(f=>({value:f.field.code,label:f.field.name?.[i18n.language === 'ar' ? 'ar' : 'en'] || f.field.name.ar,subFields:f?.maintenanceListPerDevice.flatMap(item => item.maintenanceList)})));
        }
    },[fields,vendor])

    
    const getUserData = async () => {
      try {
        const response = await apiClient.get(`/vendors/${user?._id}`);
        if(response?.data) {
          setVendor(response?.data);
        } else {

        }
      } catch(err) {}
    }

    useEffect(()=>{
        if(user && user?._id) {
            getUserData();
        }
    },[user])
      


  
    useEffect(()=>{
      if(addUserForm && addUserForm?.name && addUserForm.username && addUserForm.city && addUserForm?.governmentId && /^[12]\d{9}$/.test(addUserForm?.governmentId.toString()) && addUserForm?.field && uploadedFile)  {
        setIsAddUserFormDisabled(false);
      } else {
        setIsAddUserFormDisabled(true);
      }
    },[addUserForm,uploadedFile]);
  
    const hideError = (err) => {
      if(errors) {
        let errorsList = errors;
        delete errorsList[err];
        setErrors(errorsList);
      }
    }


    const handleSubmitAddUser = (url=false) => {
        setIsActionLoading(true);
        setErrors(null);
        let errorsList = {};
        if(addUserForm?.name?.length < 2) {
            errorsList.name = 'validation.nameLength';
            }
            if(!/^(5)([0-9]{8})$/.test(addUserForm?.username?.replace('966',''))) {
            errorsList.username = 'validation.invalidmobile';
            }
            if(Object.keys(errorsList).length > 0) {
            setErrors(errorsList);
            setIsActionLoading(false);
        } else {
            handleClickSubmitAddUserAction(url);
        }
    }

    const handleClickSubmitAddUserAction = async (url=false) => {
        setIsAddUserFormDisabled(true);
        const finalAddUserForm = {...addUserForm};
        finalAddUserForm.vendorId = vendor?._id;
        finalAddUserForm.fields = finalAddUserForm.field;
        finalAddUserForm.username = convertArabicNumbersToEnglish(finalAddUserForm.username);
        finalAddUserForm.governmentId = convertArabicNumbersToEnglish(finalAddUserForm.governmentId);
        delete finalAddUserForm.field;
        if(url){
            finalAddUserForm.residenceDocumentUrl  = url;
        }
        try {
        const response = await apiClient.post(`/workers/sign-up`,Object.fromEntries(Object.entries(finalAddUserForm).filter(([_, v]) => v !== '')));
        if(response?.data) {
            navigate(`/${i18n?.language || 'ar'}/workers`);
        } else {
            setIsAddUserFormDisabled(false);
            setIsActionLoading(false);
        }
        } catch(err) {
            setIsActionLoading(false);
            setIsAddUserFormDisabled(false);
            if(err?.response?.data?.errors) {
                let errorsList = {};
                err?.response?.data?.errors?.map(err=>{
                    errorsList[err.field] = err.message; 
                });
                setErrors(errorsList);
            }
            if(err?.response?.data?.message) {
                setToast({show:true,type:'error',message:err.response.data.message});
            }
        }
    }

   const isTechCountExceeded = () => {
      let status;
      if(vendor?.activeSubscription?.plan?.features?.TechniciansCount > 0 && vendor?.workersCount >= vendor?.activeSubscription?.plan?.features?.TechniciansCount) {
        status = true;
      } else {
        status = false;
      }
      return status;
    }


    useEffect(()=>{
        if(confguration?.enums?.districts && vendor?.city) {
            const citiesOptions = confguration?.enums?.districts?.map((city) => ({
                value: city?.id,
                label: city?.[i18n.language === 'ar' ? 'ar' : 'en'] || city?.ar
            }));
            if(Array.isArray(vendor?.city)) {
                const vendorCities = citiesOptions.filter(c=>vendor?.city?.includes(c?.value));
                setCitiesOptions(vendorCities);
            } else {
                const vendorCities = citiesOptions.filter(c=> vendor?.city === c?.value);
                setCitiesOptions(vendorCities);
            }
        }
    },[vendor?.city,confguration?.enums?.districts])

    useEffect(()=>{
        if(addUserForm?.city) {
            const districtsOptions = confguration?.enums?.districts[confguration?.enums?.districts.findIndex(district => district?.id === addUserForm?.city)]?.districts?.map((district) => ({
                value: district?.id,
                label: district?.[i18n.language === 'ar' ? 'ar' : 'en'] || district?.ar
            }));
            setAddUserForm({ ...addUserForm, district: '' });
            setDistrictsOptions(districtsOptions);
        }
    },[addUserForm?.city,confguration])


    useEffect(()=>{
        if(vendor && !vendor?.activeSubscription) {
            navigate(`/${i18n?.language || 'ar'}/settings/packages`);
        }
    },[vendor])


    useEffect(()=>{
      if(addUserForm?.field) {
          const subFieldsOptions = fieldsOptions?.filter(item => addUserForm?.field?.includes(item.value))?.flatMap(item => item.subFields)?.map(subField => ({
            value: subField.code,
            label: subField.name?.[i18n.language === 'ar' ? 'ar' : 'en'] || subField.name.ar
        }));
        setSubFieldsOptions(subFieldsOptions);
        setAddUserForm({ ...addUserForm, focusedSpecialization: addUserForm.focusedSpecialization?.filter(item => subFieldsOptions?.flatMap(i => i.value)?.includes(item)) });
      }
    },[addUserForm?.field])

    const fileRef = useRef();
    
    const ResetInputFile = () => {
        if(fileRef.current) {
            fileRef.current.value = '';
        }
    }

    const handleChangeUpload = (e) => {
        setUploadedFile(e.target.files[0]);
        ResetInputFile();
    }


    useEffect(()=>{
        if(!uploadedFile) {
            ResetInputFile();
        }
    },[uploadedFile])


    function handlUploadAction() {
        setIsActionLoading(true);
        if(uploadedFile?.type.includes('image')) {
            SingleImageCompress(uploadedFile).then(compressedFile=>setCompressedImage(compressedFile));
        } else {
            setCompressedImage(uploadedFile);
        }
    }

    useEffect(()=>{

        if(compressedImage) {
            const app = !getApps().length ? initializeApp(firebaseConfig) : getApp();
            const storage = getStorage(app);
            const file = compressedImage;
            const time = Date.parse(moment().locale('en').format('YYYY-MM-DD HH:mm:ss')) / 1000;
            const storageRef = ref(storage,'workerIdentityImageUrl/'+time);
            const uploadTask = uploadBytesResumable(storageRef, file);
            uploadTask.on(
                "state_changed",
                (snapshot) => {
                    const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                },
                (error) => {
                    setIsActionLoading(false);
                    setCompressedImage(null);
                    setToast({show:true,type:'error',message:t('workers.workerDocumentUploadError')});
                },
                () => {
                getDownloadURL(uploadTask.snapshot.ref).then((downloadedURL) => {
                    setUploadedFileUrl(downloadedURL);
                    handleSubmitAddUser(downloadedURL);
                });
                }
            );
        }

    },[compressedImage])

    const handleClickTryAddUser = () => {
        if(uploadedFile && !uploadedFileUrl) {
            handlUploadAction();
        }  else if (uploadedFileUrl) {
            handleSubmitAddUser(uploadedFileUrl);
        } else {
            handleSubmitAddUser();
        }
    }


    const getGoldiePlans = async (field,subscriptionType) => {
        setSelectedGoldiePlan(null);
        try {
          const response = await apiClient.get(`/vendor-golden-star-plans/field?field=${field}&subscriptionType=${subscriptionType}`);
          if(response?.data) {
            if(response?.data?.goldenStarPlan?.isActive) {
                setSelectedGoldiePlan(response?.data?.goldenStarPlan);
            } else {
            }
          } else {
          }
        } catch(err) {
        }
    }

    useEffect(()=>{
        if(addUserForm?.field[0]) {
            if(vendor?.activeGoldenStarSubscriptions && Array.isArray(vendor?.activeGoldenStarSubscriptions) && vendor?.activeGoldenStarSubscriptions.length > 0) {
                if(vendor?.activeGoldenStarSubscriptions.find(s=>s?.goldenStarPlan?.field === addUserForm?.field[0])) {
                    getGoldiePlans(addUserForm?.field[0],vendor?.activeGoldenStarSubscriptions.find(s=>s?.goldenStarPlan?.field === addUserForm?.field[0])?.goldenStarPlan?.subscriptionType);
                } else {
                    setSelectedGoldiePlan(null);
                }
            }
        } else {
            setSelectedGoldiePlan(null);
        }
    },[addUserForm?.field,vendor?.activeGoldenStarSubscriptions])

    const getRealFields = () => {
        return [...new Set(vendor?.workers?.flatMap(w => w.fields))];
    }

    const handleChangeFields = (options) => {
        if(options && Array.isArray(options)) {
            if(options.length > vendor?.activeSubscription?.plan?.features?.MaxSpecializationsCount) {
                setToast({show:true,type:'error',message:t('workers.maxSpecializationsReached')});
            } else {
                setAddUserForm({ ...addUserForm, field: options.map(o=>o.value) }); 
                hideError('field');
            }
        }
    }
    

    const getTotal = () => {
        let total = 0;
        if(isTechCountExceeded()) {
            total += vendor?.activeSubscription?.plan?.features?.ExtraTechsFees;
        }
        if(addUserForm?.field?.length > vendor?.activeSubscription?.plan?.features?.SpecializationsCount) {
            total += vendor?.activeSubscription?.plan?.features?.FeesToSpecializations;
        }
        if(selectedGoldiePlan && selectedGoldiePlan?.workersCountInField >= selectedGoldiePlan?.techniciansCount ) {
            total += selectedGoldiePlan?.extraTechniciansFees;
        }
        return total;
    }


  return (
    <>
         <div>
        <PageHeader pageTitle={pageTitle} />
        <PageMain>
            {vendor && citiesOptions && <MainContent>


                <div className="flex flex-wrap lg:flex-nowrap gap-[24px]">
                    <div className="w-full lg:w-[calc(100%-330px)] order-2 lg:order-1">
                        {isTechCountExceeded() 
                        ? <div className="my-[16px] lg:h-[46px] leading-[46px] bg-infoLight text-info text-[16px] font-[600] rounded-[12px] px-[12px] cairo-font relative">
                            <img src="/assets/images/info-circle-info.svg" alt="" className="inline-block me-[8px]" />
                            {t('workers.techCountExceededInfo')} {vendor?.workersCount} {t('workers.techCountExceededOf')} {vendor?.activeSubscription?.plan?.features?.TechniciansCount > 0 ? vendor?.activeSubscription?.plan?.features?.TechniciansCount  : t('workers.unlimited')} {t('workers.techCountExceededWorkers')}
                            <Link to={`/${i18n?.language || 'ar'}/settings/packages`} className="absolute text-nowrap underline cairo-font text-[16px] font-[600] text-darkBlue leading-[30px] end-[12px] top-[8px]">{t('workers.upgradePackage')}</Link>
                        </div>
                        : <div className="my-[16px] lg:h-[46px] leading-[46px] bg-darkBlue/10 text-darkBlue text-[16px] font-[600] rounded-[12px] px-[12px] cairo-font">
                            <img src="/assets/images/info-circle-green.svg" alt="" className="inline-block me-[8px]" />
                            {t('workers.techCountExceededInfo')} {vendor?.workersCount} {t('workers.techCountExceededOf')} {vendor?.activeSubscription?.plan?.features?.TechniciansCount > 0 ? vendor?.activeSubscription?.plan?.features?.TechniciansCount  : t('workers.unlimited')} {t('workers.techCountExceededWorkers')}
                        </div> }
                        <div className="px-[10px]">
                            <NormalFormContainer fullWidth={true} heading={t('workers.addWorkerFormHeading')} label={t('workers.addWorkerLabel')}>
                        
                                <div className="mb-[15px]">
                                    <InputField isRequird label={t('workers.workerFullName')} placeholder={t('workers.workerNamePlaceholder')} value={addUserForm?.name} error={errors?.name} errorMessage={errors?.name} translateError={true} onChange={(e)=>{setAddUserForm({ ...addUserForm, name: e.target.value }); hideError('name')}} />
                                </div>

                                <div className="mb-[15px]">
                                    <InputField isRequird label={t('workers.employer')} placeholder={t('workers.employerPlaceholder')} value={addUserForm?.sponsor} error={errors?.sponsor} errorMessage={errors?.sponsor} translateError={true} onChange={(e)=>{setAddUserForm({ ...addUserForm, sponsor: e.target.value }); hideError('sponsor')}} />
                                </div>

                                <div className="mb-[15px]">
                                    <InputField phone={true} isRequird label={t('workers.mobileNumber')} value={addUserForm?.username?.replace('966','')} error={errors?.username} errorMessage={errors?.username} translateError={true} onChange={(e)=>{ if(e.target.value === '' || /^[0-9\b]+$/.test(e.target.value)) { setAddUserForm({ ...addUserForm, username: '966'+e.target.value }) }; hideError('username')}} />
                                </div>

                                <div className="mb-[15px]">
                                    <InputField isRequird label={t('workers.idNumber')} placeholder={t('workers.idNumberPlaceholder')} value={addUserForm?.governmentId || ""} error={errors?.governmentId} errorMessage={errors?.governmentId} translateError={true} onChange={(e)=>{/^([12]\d{0,9})?$/.test(e.target.value.toString()) ? setAddUserForm({ ...addUserForm, governmentId: e.target.value }) : ''; hideError('governmentId')}} />
                                </div>

                                <div className="mb-[15px]">
                                    <MultiSelect isMulti isRequird label={t('workers.specialization')} placeholder={t('workers.specializationPlaceholder')} options={fieldsOptions} value={addUserForm?.field} error={errors?.field} errorMessage={errors?.field} translateError={true} onChange={(options)=>{handleChangeFields(options)}} />
                                </div>

                                {(addUserForm?.field && subFieldsOptions && subFieldsOptions.length > 0) ? <div className="mb-[15px]">
                                    <MultiSelect isMulti label={t('workers.subSpecialization')} placeholder={t('workers.subSpecializationPlaceholder')} options={subFieldsOptions} error={errors?.focusedSpecialization} errorMessage={errors?.focusedSpecialization} value={addUserForm?.focusedSpecialization} onChange={(options)=>{setAddUserForm({ ...addUserForm, focusedSpecialization: FilterSelectedValues(options)});hideError('focusedSpecialization');}} />
                                </div> : ''}

                                <div className="mb-[15px]">
                                    <SelectField isRequird label={t('workers.cityField')} placeholder={t('workers.cityPlaceholder')} options={citiesOptions} value={addUserForm?.city} error={errors?.city} errorMessage={errors?.city} translateError={true} onChange={(e)=>{setAddUserForm({ ...addUserForm, city: e.target.value }); hideError('city')}} />
                                </div>

                                {addUserForm?.city && districtsOptions && <div className="mb-[15px]">
                                    <SelectField label={t('workers.districtField')} placeholder={t('workers.districtPlaceholder')} options={districtsOptions} value={addUserForm?.district} error={errors?.district} errorMessage={errors?.district} translateError={true} onChange={(e)=>{setAddUserForm({ ...addUserForm, district: e.target.value }); hideError('district')}} />
                                </div>}

                                <div>
                                    <label htmlFor={'residenceDocumentUrl'} className="text-grey-900 text-[14px] font-[600] leading-[21px] mb-[3px] block">{t('workers.residenceDocument')} <span className="text-danger">*</span></label>
                                    <div className="flex flex-nowrap gap-x-[10px] mb-[15px]">
                                        <div className="w-[75%] text-grey-600 text-[16px] font-[500]">{t('workers.uploadResidenceDocument')}</div>
                                        <div className="w-[25%] text-end">
                                            <div className={`inline-block text-[16px] font-[500] cursor-pointer select-none text-blue relative`}>
                                                <input type="file" id="file" name="file" accept=".pdf,.png,.jpg,.jpeg" ref={fileRef} onChange={handleChangeUpload} className="absolute top-0 left-0 w-full h-full opacity-0 cursor-pointer" />
                                                <span dir="lrt inline-block h-[24px] leading-[24px]">{t('workers.uploadDocument')}</span>
                                                <span className="inline-block align-top w-[24px] h-[24px] ms-[5px]" style={{background:"url('/assets/images/export.svg')"}}></span>
                                            </div>
                                        </div>
                                    </div>
                                    {uploadedFile && <div className="flex flex-nowrap gap-x-[10px] mb-[15px] mt-[-5px]">
                                        <div className="text-[16px] font-[500] text-grey-600">
                                            <span className="inline-block align-middle w-[24px] h-[24px] me-[3px]" style={{background:"url('/assets/images/tick-circle.svg')"}}></span>
                                            {uploadedFile?.name}
                                            <span className="inline-block align-middle w-[24px] h-[24px] ms-[6px] cursor-pointer select-none" style={{background:"url('/assets/images/close-square.svg')"}} onClick={()=>{setUploadedFile(null); setUploadedFileUrl(null);}}></span>
                                        </div>
                                    </div>}
                                </div>
                                

                                <div className="text-end">
                                    <NormalButton label={t('workers.addWorkerButton')} onClick={handleClickTryAddUser} isDisabled={isAddUserFormDisabled} />
                                </div>

                            </NormalFormContainer>
                        </div>
                    </div>
                    <div className="w-full lg:w-[330px] lg:pt-[120px] order-1 lg:order-2">
                        {getTotal() > 0 && <div className="bg-white p-[16px] rounded-[8px]">
                            {isTechCountExceeded() && <div className="flex flex-nowrap pb-[16px] border-b-[1px] border-grey-300 border-dashed">
                                <div className="w-[75%] text-[16px] text-grey-600 font-[500] leading-[24px]">{t('workers.addNewWorkerCost')}</div>
                                <div className="w-[25%] text-end text-[14px] text-grey-900 font-[500]">{vendor?.activeSubscription?.plan?.features?.ExtraTechsFees} <img src="/assets/images/pack-sar.svg" alt="" className="inline-block align-baseline max-w-[11px] me-[4px]" /></div>
                            </div>}
                            {addUserForm?.field?.length > vendor?.activeSubscription?.plan?.features?.SpecializationsCount ? <div className="py-[16px] border-b-[1px] border-grey-300 border-dashed flex flex-nowrap">
                                <div className="w-[75%] text-[16px] text-grey-600 font-[500] leading-[24px]">{t('workers.addNewSpecializationCost')}</div>
                                <div className="w-[25%] text-end text-[14px] text-grey-900 font-[500]">{vendor?.activeSubscription?.plan?.features?.FeesToSpecializations || 0} <img src="/assets/images/pack-sar.svg" alt="" className="inline-block align-baseline max-w-[11px] me-[4px]" /></div>
                            </div> : ''}
                            {selectedGoldiePlan && selectedGoldiePlan?.workersCountInField >= selectedGoldiePlan?.techniciansCount ? <div className="py-[16px] border-b-[1px] border-grey-300 border-dashed flex flex-nowrap">
                                <div className="w-[75%] text-[16px] text-grey-600 font-[500] leading-[24px]">{t('workers.goldieSubscription')}</div>
                                <div className="w-[25%] text-end text-[14px] text-grey-900 font-[500]">{selectedGoldiePlan?.extraTechniciansFees || 0} <img src="/assets/images/pack-sar.svg" alt="" className="inline-block align-baseline max-w-[11px] me-[4px]" /></div>
                            </div> : ''}
                            <div className="py-[16px] flex flex-nowrap">
                                <div className="w-[75%] text-[16px] text-grey-600 font-[500] leading-[24px]">{t('workers.totalToPay')}</div>
                                <div className="w-[25%] text-end text-[14px] text-grey-900 font-[500]">{getTotal()} <img src="/assets/images/pack-sar.svg" alt="" className="inline-block align-baseline max-w-[11px] me-[4px]" /></div>
                            </div>
                            {getTotal() > vendor?.credits && <div className="h-[29px] flex flex-nowrap">
                                <div className="w-[calc(100%-90px)] text-[14px] text-danger font-[500] leading-[29px]">{t('workers.insufficientBalance')}</div>
                                <div className="w-[90px] text-end">
                                    <Link to={`/${i18n?.language || 'ar'}/wallet`} className="inline-block bg-blue text-white text-center text-[14px] font-[500] h-[29px] leading-[29px] w-[90px] rounded-[8px]" reloadDocument>{t('workers.chargeWallet')}</Link>
                                </div>
                            </div>}
                        </div>}
                    </div>
                </div>

                <br />
                <br />
                
            </MainContent>}
        </PageMain>

        <Toast toast={toast} setToast={setToast} />
        </div>

        {(!vendor || !citiesOptions || isActionLoading) && <Loading showLoading={true} />}
    </>
  );
};

export default UsersAddPage;
